class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 500);
    
    const facetForm = this.querySelector('form');
    const buttonSubmitForm = this.querySelector('.button-apply-filter');
    const buttonCloseMobile = $('.mobile-facets__close');

    const buttonApplyMobileInterval = setInterval(() => {
      const buttonApplyMobile = $('#button-apply-filter-mobile');
      if(buttonApplyMobile.length > 0) {
        buttonApplyMobile.off('click').on('click', function(event) {
          this.closest('menu-drawer').closeMenuDrawer(event, false, true)
        })
        clearInterval(buttonApplyMobileInterval)
      }
    }, 500)
    
    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');
    document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');
    if (countContainer) {
      countContainer.classList.add('loading');
    }
    if (countContainerDesktop) {
      countContainerDesktop.classList.add('loading');
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = (element) => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl)
        ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
        : FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
        if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
      }).then(() => {
        document.querySelectorAll(LoadMoreProduct.definedTagName).item(0).setAttributes({ currentPage: 2 }).setSelectors();
        LoadMoreProduct.renderSections({ skip: 1 });
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
    if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
  }

  static renderProductGridContainer(html) {
    document.getElementById('ProductGridContainer').innerHTML = new DOMParser()
      .parseFromString(html, 'text/html')
      .getElementById('ProductGridContainer').innerHTML;

    document
      .getElementById('ProductGridContainer')
      .querySelectorAll('.scroll-trigger')
      .forEach((element) => {
        element.classList.add('scroll-trigger--cancel');
      });
      if (typeof ReloadSmartWishlist == 'function') {
        setTimeout(() => {
          ReloadSmartWishlist();
        }, 400);
      }
  }

  static renderProductCount(html) {
    const count = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCountDesktop')?.innerHTML;
    const containerDesktop = document.getElementById('ProductCountDesktop');

    if (containerDesktop) {
      containerDesktop.innerHTML = count;
      containerDesktop.classList.remove('loading');
    }
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

    const facetDetailsElements = parsedHTML.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
    );
    const matchesIndex = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.dataset.index === jsFilter.dataset.index : false;
    };
    const facetsToRender = Array.from(facetDetailsElements).filter((element) => !matchesIndex(element));
    const countsToRender = Array.from(facetDetailsElements).find(matchesIndex);

    facetsToRender.forEach((element) => {
      document.querySelector(`.js-filter[data-index="${element.dataset.index}"]`).innerHTML = element.innerHTML;
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender) {
      const closestJSFilterID = event.target.closest('.js-filter').id;
      const currentActiveID = document.activeElement.id;

      if (closestJSFilterID) {
        FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));
        FacetFiltersForm.renderMobileCounts(countsToRender, document.getElementById(closestJSFilterID));

        const newElementToActivate = document.getElementById(currentActiveID);
        if (newElementToActivate) newElementToActivate.focus();
      }
    }
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    });

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting'];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
    });

    document.getElementById('FacetFiltersFormMobile').closest('menu-drawer').bindEvents();
  }

  static renderCounts(source, target) {
    const targetSummary = target.querySelector('.facets__summary');
    const sourceSummary = source.querySelector('.facets__summary');

    if (sourceSummary && targetSummary) {
      targetSummary.outerHTML = sourceSummary.outerHTML;
    }

    const targetHeaderElement = target.querySelector('.facets__header');
    const sourceHeaderElement = source.querySelector('.facets__header');

    if (sourceHeaderElement && targetHeaderElement) {
      targetHeaderElement.outerHTML = sourceHeaderElement.outerHTML;
    }

    const targetWrapElement = target.querySelector('.facets-wrap');
    const sourceWrapElement = source.querySelector('.facets-wrap');

    if (sourceWrapElement && targetWrapElement) {
      const isShowingMore = Boolean(target.querySelector('show-more-button .label-show-more.hidden'));
      if (isShowingMore) {
        sourceWrapElement
          .querySelectorAll('.facets__item.hidden')
          .forEach((hiddenItem) => hiddenItem.classList.replace('hidden', 'show-more-item'));
      }

      targetWrapElement.outerHTML = sourceWrapElement.outerHTML;
    }
  }

  static renderMobileCounts(source, target) {
    const targetFacetsList = target.querySelector('.mobile-facets__list');
    const sourceFacetsList = source.querySelector('.mobile-facets__list');

    if (sourceFacetsList && targetFacetsList) {
      targetFacetsList.outerHTML = sourceFacetsList.outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      },
    ];
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    if (event) {
      event?.preventDefault();
      const sortFilterForms = document.querySelectorAll('facet-filters-form form');
      if (event?.srcElement.className == 'mobile-facets__checkbox') {
        const searchParams = this.createSearchParams(event.target.closest('form'));
        this.onSubmitForm(searchParams, event);
      } else {
        const forms = [];
        const isMobile = event?.target?.closest('form').id === 'FacetFiltersFormMobile';

        sortFilterForms.forEach((form) => {
          if (!isMobile) {
            if (form.id === 'FacetSortForm' || form.id === 'FacetFiltersForm' || form.id === 'FacetSortDrawerForm') {
              const noJsElements = document.querySelectorAll('.no-js-list');
              noJsElements.forEach((el) => el.remove());
              forms.push(this.createSearchParams(form));
            }
          } else if (form.id === 'FacetFiltersFormMobile') {
            forms.push(this.createSearchParams(form));
          }
        });
        this.onSubmitForm(forms.join('&'), event);
      }
    } else {
      const forms = [];
      const isMobile = event?.target?.closest('form')?.id === 'FacetFiltersFormMobile';

      const sortFilterForms = document.querySelectorAll('facet-filters-form form');
      sortFilterForms.forEach((form) => {
        if (!isMobile) {
          if (form.id === 'FacetSortForm' || form.id === 'FacetFiltersForm' || form.id === 'FacetSortDrawerForm') {
            const noJsElements = document.querySelectorAll('.no-js-list');
            noJsElements.forEach((el) => el.remove());
            forms.push(this.createSearchParams(form));
          }
        } else if (form.id === 'FacetFiltersFormMobile') {
          forms.push(this.createSearchParams(form));
        }
      });
      this.onSubmitForm(forms.join('&'), event);
    }
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url =
      event.currentTarget.href.indexOf('?') == -1
        ? ''
        : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
  }
}

const interval = setInterval(() => {
  if($('facet-filters-form').length > 0)
    {
      FacetFiltersForm.filterData = [];
      FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
      FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
      customElements.define('facet-filters-form', FacetFiltersForm);
      FacetFiltersForm.setListeners();
      clearInterval(interval);
    }
}, 500)

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('input').forEach((element) =>
      element.addEventListener('change', this.onRangeChange.bind(this))
    );
    this.setMinAndMaxValues();
    publish('price-range-mounted')
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute('max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('min', 0);
    if (maxInput.value === '') minInput.setAttribute('max', maxInput.getAttribute('max'));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('min'));
    const max = Number(input.getAttribute('max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}

customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    form.onActiveFilterClick(event);
  }
}

const facetRemoveInterval = setInterval(() => {
  if($('facet-remove').length > 0)
  {
    customElements.define('facet-remove', FacetRemove);
    clearInterval(facetRemoveInterval)
  }
}, 500)

function redirectToPathname(newPathname) {
  var newUrl = window.location.origin + newPathname;
  window.location.href = newUrl;
}

$('#button-reset-filter').click(function () {
  const pathname = window.location.pathname;
  redirectToPathname(pathname);
});

class CollectionDescription extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', function (event) {
      const sectionId = this.getAttribute('data-collection-id');
      const textElement = document.getElementById(`collection__description__text-${sectionId}`);
      const button = document.getElementById(`collection__description__button-${sectionId}`);

      const currentStyle = textElement.style.cssText;

      if (currentStyle.includes('-webkit-line-clamp: 2;')) {
        const updatedStyle = currentStyle.replace('-webkit-line-clamp: 2;', '');
        textElement.style.cssText = updatedStyle;
        button.style.transform = 'rotate(180deg)';
      } else {
        textElement.style.cssText = currentStyle + ' -webkit-line-clamp: 2;';
        button.style.transform = 'rotate(0deg)';
      }
    });
  }
}

customElements.define('collection-description', CollectionDescription);

class CollectionDescriptionExpand extends HTMLElement {
  constructor() {
    super();
    this.clickCount = 0;

    this.collectionDescriptionElement = this.querySelector('.collection__description');
    this.collectionDescriptionElement.addEventListener('click', this.handleCollectionDescriptionClick.bind(this));
  }

  handleCollectionDescriptionClick(event) {
    const sectionId = this.getAttribute('data-collection-id');
    const textElementExpand = document.getElementById(`collection__description__text__expand-${sectionId}`);
    const button = document.getElementById(`collection__description__button-${sectionId}`);

    this.clickCount++;

    if (this.clickCount % 2 === 1) {
      textElementExpand.style.display = 'block';
      button.style.transform = 'rotate(180deg)';
    } else {
      textElementExpand.style.display = 'none';
      button.style.transform = 'rotate(0deg)';
    }
  }
}

customElements.define('collection-description-expand', CollectionDescriptionExpand);

class LoadMoreProduct extends HTMLElement {
  constructor() {
    super();
    
    const self = this;
    this.setSelectors();
    this.currentPage = 1;
    if (!isNaN(this.dataset.currentPage)) {
      this.currentPage = parseInt(this.dataset.currentPage) + 1;
    }
    this.fetch = true;

    $(self).find('button.js-load-more').on('click', () => this.onLoadMoreClickHandle(self));
    $(window).on('scroll', () => {
      const bottomPosition = self.getBoundingClientRect().bottom - 800 + 1000 * (self.dataset.currentIndex ?? 0);

      if($(self).css('display') !== 'none' && bottomPosition < 0) {
        LoadMoreProduct.renderSections({ skip: 1, callback: () => $('#main-collection').focus() });
        $(window).off('scroll');
      }
    });
  }

  static get definedTagName() {
    return 'load-more-product';
  }

  setSelectors() {
    this.loadMore = this.querySelector('.load-more_wrap');
    this.productGridWrapper = this.getElementsByClassName('product-grid').item(0);
  }

  onLoadMoreClickHandle(element) {
      LoadMoreProduct.renderSection(element);
  }

  setAttributes(attributes = {}) {
    const defaultAttrs = {
      fetch: true,
      previousPage: 0,
      currentPage: 1
    };

    const mergeAttrs = Object.assign(defaultAttrs, attributes);

    this.fetch = mergeAttrs.fetch;
    this.previousPage = mergeAttrs.previousPage;
    this.currentPage = mergeAttrs.currentPage;
    return this;
  }

  static renderSections(options = { skip: 0, callback: null }) {
    let elements = document.querySelectorAll(`${LoadMoreProduct.definedTagName}`);
    if (options.skip > 0) {
      elements = Array.prototype.slice.call(elements, options.skip);
    }

    for(let element of elements) {
      element.setAttributes();
      element.style.display = 'none';
      element.productGridWrapper.innerHTML = "";
      element.setSelectors();
      LoadMoreProduct.renderSection(element, options.callback);
    }
  }

  static renderSection(element, callback = null) {
    if (element && element.dataset?.collectionUrl) {
      const pageUrl = new URL(document.location.href);
      pageUrl.searchParams.set('page', element.currentPage);
      pageUrl.searchParams.set('limit', element.dataset.pageSize);
      const collectionUrl = `${pageUrl.origin}${element.dataset.collectionUrl}${pageUrl.search}`;
      if (element.fetch && element.previousPage != element.currentPage) {
        element.previousPage = element.currentPage;
        LoadMoreProduct.renderCollectionProductGrid(element, collectionUrl, callback);
      }
    }
  }

  static renderCollectionProductGrid(element, collectionUrl, callback = null) {
    if (element.loadMore) {
      $(element.loadMore).find('.loading-icon').css({ display: 'block' });
    }
    fetch(collectionUrl)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;
        const domData = new DOMParser().parseFromString(html, 'text/html').querySelectorAll(`${LoadMoreProduct.definedTagName}`)[0].querySelectorAll('.product-grid .grid__item');
        if (domData.length > 0) {
          Array.prototype.slice.call(domData).forEach(productHtml => {
            element.productGridWrapper.append(productHtml);
          });
          element.fetch = true;
          element.currentPage += 1;
          element.style.display = null;
        } else {
          $(element.loadMore).css({ display: 'none' })
          element.fetch = false;
        }
      })
      .finally(() => {
        if (element.loadMore) {
          $(element.loadMore).find('.loading-icon').css({ display: 'none' });
          callback && callback();
        }
        if (typeof ReloadSmartWishlist == 'function') {
          ReloadSmartWishlist();
        }
      });
  }
}

customElements.define(`${LoadMoreProduct.definedTagName}`, LoadMoreProduct);